module.exports = __webpack_public_path__ + "static/media/delete.0b3cf092.svg";